module.exports = __webpack_public_path__ + "img/stick_hiver_ski_nordique.87a229e3.svg";